// extracted by mini-css-extract-plugin
export default {"sectionWrapper":"styles_sectionWrapper__U4Pev","wrapper":"styles_wrapper__8woKd","element":"styles_element__Q+Au5"};